import CollectionsIcon from '@mui/icons-material/Collections'
import BuildIcon from '@mui/icons-material/Build'
import ApiIcon from '@mui/icons-material/Api'
import SettingsIcon from '@mui/icons-material/Settings'
import ControlPointIcon from '@mui/icons-material/ControlPoint'
import PaymentIcon from '@mui/icons-material/Payment'
import ColorLensIcon from '@mui/icons-material/ColorLens'
import PermMediaIcon from '@mui/icons-material/PermMedia'
import LayersIcon from '@mui/icons-material/Layers'
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions'
import KeyIcon from '@mui/icons-material/Key'

import DashboardGallery from '../components/dashboard/gallery'
import DashboardRequest from '../components/dashboard/request'
import Blueprint from '../components/dashboard/blueprint'
import Settings from '../components/dashboard/settings'
import ProjectList from '../components/dashboard/project-select'

import ApiKeys from '../components/settings/api-keys'
import ConnectionSettings from '../components/settings/connections'
import Plan from '../components/settings/plan'
import Theme from '../components/settings/theme'
import Media from '../components/dashboard/media'
import Version from '../components/dashboard/version'
import General from '../components/settings/general'

export const DashboardNavigationItems = {
    _id: "dashboard",
    _showRun: true,
    _showBack: false,
    _changeOrg: true,
    Request: {
        _show: true,
        id: 'Request',
        Icon: () => <ApiIcon fontSize='s' />,
        Component: () => <DashboardRequest />,
    },
    Gallery: {
        _show: true,
        id: 'Gallery',
        Icon: () => <CollectionsIcon fontSize='s'/>,
        Component: () => <DashboardGallery />,
    },
    Blueprint: {
        _show: true,
        id: 'Blueprint',
        Icon: () => <BuildIcon fontSize='s'/>,
        Component: () => <Blueprint />,
    },    
    Version: {
        _show: true,
        _requiresDeveloper: true,
        id: 'Version',
        Icon: () => <LayersIcon fontSize='s'/>,
        Component: () => <Version />,
    },
    Media: {
        _show: true,
        id: 'Media',
        Icon: () => <PermMediaIcon fontSize='s'/>,
        Component: () => <Media />,
    },
    Settings: {
        _show: true,
        id: 'Settings',
        Icon: () => <SettingsIcon fontSize='s'/>,
        Component: () => <Settings />,
    }
}

export const HomepageNavigationItems = {
    _id: "homepage",
    _showRun: false,
    _showBack: false,
    _changeOrg: false,
    ProjectList: {
        _show: false,        
        id: 'ProjectList',
        Icon: () => null,
        Component: () => <ProjectList />,
    }
}

export const SettingsNavigationItems = {
    _id: "settings",
    _showRun: false,
    _showBack: true,
    _changeOrg: false,
    General: {
        _show: true,
        id: 'General',
        Icon: () => <SettingsIcon />,
        Component: () => <General />
    },
    Connections: {       
        _show: true,
        id: 'Connections',
        Icon: () => <ControlPointIcon />,
        Component: () => <ConnectionSettings />
    },
    Plan: {        
        _show: true,
        id: 'Plan',
        Icon: () => <PaymentIcon />,
        Component: () => <Plan />
    },
    Appearance:{        
        _show: true,
        id: 'Appearance',
        Icon: () => <ColorLensIcon/>,
        Component: () => <Theme />
    },     
    ApiKeys: {
        _category: "developer",
        _show: true,
        _name: "API Keys",
        _requiresDeveloper: true,
        id: 'ApiKeys',
        Icon: () => <KeyIcon />,
        Component: () => <ApiKeys />
    }
    
}

export const NavigationMap = {
    [SettingsNavigationItems._id]:SettingsNavigationItems,
    [DashboardNavigationItems._id]:DashboardNavigationItems,
    [HomepageNavigationItems._id]:HomepageNavigationItems,
}